import './style/mandatory.css';

import React, { useEffect } from "react";
import { FormattedMessage, injectIntl, IntlProvider } from "react-intl";
import { Provider as ReduxProvider } from "react-redux";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { Provider, Subscribe } from "unstated";
import UNSTATED from "unstated-debug";

import { ErrorComponent, ErrorComponentLinkExpired } from "./Components/Common";
import DI3ds from "./Components/DI3ds";
import TopBuildPaymentOnAccount from "./Components/staticPages/PaymentOnAccount";
import { alertAlertAtion,alertAlertAtionWithParam, showDropdownALert, showTxnLimitALert } from "./redux/actions/alertAction";
import { alertConfirmActionWithCustomParameters, alertConfirmAlertAction } from "./redux/actions/alertConfirmAction";
import { store as reduxStore } from "./redux/store";
import LanguageDataContainer from "./Stores/LanguageDataContainer";
import myGlobals from "./Utils/globals";
import FirstLoading from "./Views/FirstLoading";
import { TopBuildPayThroughEmail } from "./Components/staticPages";
import { MainApp } from "./Components/MainApp";
import { PaymentCompleted, PaymentFailed } from "./Components/Payment";
import {myUtilities} from './Utils';
import ThemeSelector from "./Components/theme/ThemeSelector";
import PaymentInProgressPage from './Components/Payment/PaymentInProgressPage';
import { PaymentStatuses } from './Utils/utils';

UNSTATED.logStateChanges = false;
const urlParams = new URLSearchParams(window.location.search);
myGlobals.token = myUtilities.getParameter("token");
const reDirectParam = myUtilities.getParameter("redirect");
myGlobals.reDirectParamInURL =
  (reDirectParam != null && reDirectParam !== undefined ) ? reDirectParam : true;
const langCodeDLP = myUtilities.getParameter("langCode");
myGlobals.langCodeDLP =
  (langCodeDLP != null && langCodeDLP !== undefined ) ? langCodeDLP : "NA";
myGlobals.linkTerminatedReason = <FormattedMessage
  id="Error.InvalidLink"
  defaultMessage="Link has become invalid."
/>

export var selectedCard = -1;
let paymentCardKeyCount = new Set();
let cc3dsResponse = null;

if (process.env.NODE_ENV.localeCompare("development") === 0)
  window.rsaEncrypt = function (text) {
    return text;
  };
myGlobals.initialLink = window.location.href;
myGlobals.initialHost = "https://" + window.location.hostname;
myGlobals.appender = "/radiusoneweb/";
let creditCardResponse = null;
let directDebitResponse = null;
window.processCCPayment = function (jsonString) {
  console.log("jsonstring: " + jsonString);
  myGlobals.jsonString = jsonString;
  myGlobals.selectedStateMethodPaymentContainer("PROCESSING");
};
window.processDCPayment = function (jsonString) {
	  console.log("jsonstring for DC: " + jsonString);
	  myGlobals.isDCFlow = true;
	  myGlobals.jsonString = jsonString;
	  myGlobals.selectedStateMethodPaymentContainer("PROCESSING");
};
window.cc3dsFunction = function (message) {
  console.log(message);
  cc3dsResponse = message;
  //alert('triggered 3ds route');
  myGlobals.getHistory.replace(`/3dsDI`);
};
window.failureFunction = function (message) {
  console.log(message);
  myGlobals.getHistory.replace(`/paymentfailed`);
};
window.parentFuncFailureDC = function (message) {
  console.log(message);
  callReduxAlertAction(
    "Error.DebitCardinCC",
    "Debit card payment cannot be made in Credit Card flow"
  );
  if(myGlobals.currentTheme !== 'modernUX.css')
  	window.currentComponent.resetContainer();
  else 
    myGlobals.resetPaymentMethods();
};
window.parentFuncFailureCC = function (message) {
	  console.log(message);
	  callReduxAlertAction(
	    "Error.CreditCardinDC",
	    "Credit card payment cannot be made in Debit Card flow"
	  );
	  if(myGlobals.currentTheme !== 'modernUX.css')
	  	window.currentComponent.resetContainer();
	  else myGlobals.resetPaymentMethods();
};
window.myFunction = function (message) {
  console.log(message);
  creditCardResponse = message;
  myGlobals.getHistory.replace(`/completepayment`);
};
window.inProgressPayment = function(jsonString) {
  myGlobals.jsonString = jsonString;
  myGlobals.getHistory.replace(`/paymentInprogress`);
}
window.getGuestPayBankSaleResponse = function (message) {
  console.log("Received message from Direct Debit iframe:", message);
  let data = JSON.parse(message);
  directDebitResponse = data.rows;
  if (data.rows && String(data.rows.paymentStatus).toLowerCase() === PaymentStatuses.SUCCESS_STAUS) {
    myGlobals.getHistory.replace(`/completeDirectDebit`);
  } else if (data.rows && String(data.rows.paymentStatus).toLowerCase() === PaymentStatuses.IN_PROGRESS_STATUS 
        && data.rows.transactionID != null){
    data.rows.paymentType = 'ACH';
    window.inProgressPayment(data.rows)
  }else {
    myGlobals.getHistory.replace(`/paymentfailed`);
  }
};

export let isTopBuild = null;
let recieptDownloadCheck = true;
let sepaDIPageConfigs = null;
let isTermsSelected = false;
let showTermsAndConditions = false;


class RoutedApp extends React.Component {
  render(){
    return(
      <Switch>  
        <Route exact path='/error' render={(props) => <ErrorComponent {...props} isTopBuild={isTopBuild} errorMessage={myGlobals.errorMessage} />}/>
        <Route exact path='/linkExpired' render={(props) => <ErrorComponentLinkExpired {...props} isTopBuild={isTopBuild} errorMessage={myGlobals.errorMessage} />}/>
		    <Route exact path='/invalidConfig' render={(props) => <ErrorComponentLinkExpired {...props} isTopBuild={isTopBuild} errorMessage={myGlobals.errorMessage} />}/>
        <Route exact path='/genericpaythroughemail' component={injectIntl(TopBuildPayThroughEmail)}/>
        <Route exact path='/genericpaymentonaccount' component={injectIntl(TopBuildPaymentOnAccount)}/>
        <Route exact path='/mainapp' component={injectIntl(MainApp)}/>
        <Route exact path='/completepayment' render={(props) => <PaymentCompleted {...props} creditCardResponse={creditCardResponse} />}/>
        <Route exact path='/completeDirectDebit' render={(props) => <PaymentCompleted {...props} isDirectDebit directDebitResponse={directDebitResponse} />} />
        <Route exact path='/completepaymentACH' render={(props) => <PaymentCompleted {...props}  isAch={myGlobals.ACHPaymentCompleted} />}/>
        <Route exact path='/paymentfailed' render={(props) => <PaymentFailed {...props} />}/>
        <Route exact path='/3dsDI'   render={(props) => <DI3ds {...props} cc3dsResponse={cc3dsResponse} />} />
        <Route exact path='/loading' component={FirstLoading}/>
        <Route exact path="/paymentInprogress"  render={(props) => <PaymentInProgressPage {...props}/>} />
        <Route path='/' component={injectIntl(MainApp)}/>
      </Switch>
    );
  }
}

export const callReduxAlertAction = (id, message, additionalItems = []) =>
  reduxStore.dispatch(
    alertAlertAtion({
      id: id,
      message: message,
      additionalItems: additionalItems,
    })
  );
  
 export const callReduxAlertActionWithParameter = (id, message, value) =>
  reduxStore.dispatch(
    alertAlertAtionWithParam({
      id: id,
      message: message,
	  value: value
    })
  );

export const callReduxConfirmAlertAction = (id, message, custNums = "") =>
  reduxStore.dispatch(
    alertConfirmAlertAction({
      id: id,
      message: message,
      custNums: custNums,
    })
  );
  
 export const callReduxForTxnLimitALert = (id, message, value) => {
	    reduxStore.dispatch(
	      showTxnLimitALert({
	        id: id,
	        message: message,
	        value: value,
	      })
	    );
};

export const callReduxForDropdownAlert = async () => {
  
  reduxStore.dispatch(
    showDropdownALert()
  );
  return -1;
};

export const callReduxConfirmAlertActionWithParameter = (
	headerId,
	headerDefaultText,
	id,
	message,
	value,
	okButtonId,
	okButtonDefaultText,
	additionalItems = []
) =>
	reduxStore.dispatch(
		alertConfirmActionWithCustomParameters({
			headerId: headerId,
			headerDefaultText: headerDefaultText,
			id: id,
			message: message,
			value: value,
			okButtonId: okButtonId,
			okButtonDefaultText: okButtonDefaultText,
			additionalItems: additionalItems
		})
	);

// Module exports are readonly by design.
export var globalVars = {
  paymentCardKeyCount,
  selectedCard,
  showTermsAndConditions,
  sepaDIPageConfigs,
  isTermsSelected,
  recieptDownloadCheck,
};

function App() {
  let languageContainer=null;
  const setLanguageContainer = (data) => {
    languageContainer = data;
  }
  useEffect(
    ()=>{
      myGlobals.languageContainer = languageContainer
    },
    [languageContainer]
  );
  return (
		<ReduxProvider store={reduxStore}>
		<Provider>
	      <Subscribe to={[LanguageDataContainer]}>
	        {(data) => {
	          return data.state.loading ? (
	            <FirstLoading />
	          ) : data.state.linkInactive ? (
	                  <ErrorComponent
	                  errorMessage=
	                    {myGlobals.linkTerminatedReason}
	                  
	                />
	              ) : (
	            <IntlProvider
	              locale={data.getLanguage()}
	              key={data.getLanguage()}
	              messages={data.getMessages()}
	            > 
	            <ThemeSelector>
	              <BrowserRouter basename={"/radiusoneweb/payThroughEmail"}>
	                {setLanguageContainer(data)}
	                <RoutedApp />
	              </BrowserRouter>
	             </ThemeSelector>
	            </IntlProvider>
	          );
	        }}
	      </Subscribe>
	    </Provider>
	    </ReduxProvider>
  );
}

export default App;
